import { ChickletPrimaryDisplayLabel } from '../../../constants/BehaviorTypes';
import DefaultChickletPrimaryDisplayLabelRedesign from '../../../behaviors/default/DefaultChickletPrimaryDisplayLabelRedesign';

/**
 * Default redesign extension - sparse implementation
 * Only include behaviors that should be overridden for ALL object types in the redesign.
 * Most behaviors will fall back to the regular defaults unless specified here.
 */
export const Default = {
  [ChickletPrimaryDisplayLabel]: () => DefaultChickletPrimaryDisplayLabelRedesign
};